<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Edit Marketing Staff",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Edit Marketing Staff",
            items: [
               {
                  text: "Marketing Staffs",
                  href: "/marketing-staffs",
               },
               {
                  text: "Edit Marketing Staff",
                  active: true,
               },        
            ],

            staff: {
               name: '',
               mobile: '',
               whatsapp_number: '',
               commision: '',
               email: '',
               address: '',
               id_proof: '',
            },

            image: "",
            preview_image: "",

            errors: {},
            
            loading: false,

         };
      },
      mounted() {
    
      },

      created() {
         this.fetchStaff();
      },

      methods: {

         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         }, 

         noSpaces(event) {
            let keyCode = event.keyCode;
            if(keyCode == 32) {
               event.preventDefault();
            } else {
               return;
            }
         },

         alphaSpacesOnly(event) {
            let keyCode = event.keyCode;
            if ((keyCode >= 65 && keyCode <= 90) || 
               (keyCode >= 97 && keyCode <= 122) ||               
               (keyCode == 32)) {
                 return;
            } else {
               event.preventDefault();
            }
         },

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchStaff() {
            let url = "api/admin/marketingstaff/details?id=" + this.$route.params.id;         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.staff = responseData.marketing_staff;  
                     
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         setFile(e) {
            this.image = e.target.files[0];
            this.preview_image = URL.createObjectURL(e.target.files[0]);
         },

         updateStaff() {
            this.getToken();
            this.loading = true;
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/marketingstaff/edit";

            let formData = new FormData();
            formData.append("id", this.staff.id); 
            formData.append("name", this.staff.name); 
            formData.append("whatsapp_number", this.staff.whatsapp_number); 
            formData.append("commission", this.staff.commission); 
            formData.append("phone", this.staff.mobile); 
            formData.append("referral_code", this.staff.referral_code); 

            if(this.staff.email) {
               formData.append("email", this.staff.email); 
            } else {
               formData.append("email", ""); 
            }            
            

            if(this.staff.address) {
               formData.append("address", this.staff.address); 
            } else {
               formData.append("address", ""); 
            }
            

            if(this.image) {
               formData.append("id_proof", this.image); 
            }
            
           
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.$router.push({ name: 'marketingstaffs'});
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'marketingstaffs' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form" @submit.prevent="updateStaff()">
                        <div class="row">
                           <div class="form-group col-md-6">
                              <label>Name <span class="text-danger">*</span></label>
                              <input type="text" v-model="staff.name" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.name) }" @keypress="alphaSpacesOnly"/>

                              <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>                     
                                 
                           <div class="form-group col-md-6">
                              <label>Mobile No. <span class="text-danger">*</span></label>
                              <b-input-group size="sm" prepend="+91">
                                 <input type="text" v-model="staff.mobile" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.phone) }"  @keypress="numbersOnly" maxlength="10"/>

                                 <div v-for="(val, index) in errors.phone" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-input-group>
                           </div>

                           <div class="form-group col-md-6">
                              <label>Email <span class="text-danger">*</span></label>
                              <input type="email" v-model="staff.email" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.email) }" />

                              <div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>

                           <div class="form-group col-md-6">
                              <label>Commision <span class="text-danger">*</span></label>
                              <input type="text" v-model="staff.commission" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.commission) }" />

                              <div v-for="(val, index) in errors.commission" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>

                           <div class="form-group col-md-6">
                              <label>Referral Code <span class="text-danger">*</span></label>
                              <input type="text" v-model="staff.referral_code" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.referral_code) }" />

                              <div v-for="(val, index) in errors.referral_code" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>

                           <div class="form-group col-md-6">
                              <label>Whatsapp No. <span class="text-danger">*</span></label>
                              <b-input-group size="sm" prepend="+91">
                                 <input type="text" v-model="staff.whatsapp_number" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.whatsapp_number) }"  @keypress="numbersOnly" maxlength="10"/>

                                 <div v-for="(val, index) in errors.whatsapp_number" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-input-group>
                           </div>
                           
                           <div class="form-group col-md-12">
                              <label>Address</label>
                              <textarea rows="2" v-model="staff.address" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.address) }"></textarea>

                              <div v-for="(val, index) in errors.address" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>   

                           <div class="form-group col-md-6">
                              <label>ID Proof <span class="text-danger">*</span> <span class="small">[Allowed formats: .jpg, .jpeg, .png]</span></label><br>
                              <a href="#" target="_blank" v-if="staff.id_proof">
                                 <img :src="$image_url + staff.id_proof" alt="ID Proof" class="avatar-md mb-2">
                              </a>                            
                              <input type="file" @change="setFile($event)" accept=".png,.jpg,.jpeg" class="form-control" :class="{ 'is-invalid': Boolean(errors.id_proof) }" />
                              <p class="small">(Leave this field empty if you don't want to change the image)</p>
                              <img v-if="preview_image" class="avatar-sm mt-2" :src="preview_image">

                              <div v-for="(val, index) in errors.id_proof" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>                   
                           
                        </div>

                        <div class="row mt-3">
                           <div class="12">
                              <div v-if="loading" class="page-loader">
                                 <img src="@/assets/images/preloaderspin.gif"/>
                              </div>
                              <div v-else>
                                 <button class="btn btn-primary me-2" type="submit">Save</button>
                                 <router-link :to="{ name: 'marketingstaffs' }" class="btn btn-light">Cancel</router-link>
                              </div>
                           </div>
                        </div>
                     </form>
                  </b-card>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>

<style scoped>
   .page-loader {
      display: flex;
      align-items: center;
      padding: 10px 0;
   }

   .page-loader img {
      width: 50px;
      height: 50px;
   }
</style>
